import dynamic from "next/dynamic";
import TopBar from "@components/TopBar";

function BasicLayout({ children }: { children: JSX.Element }) {
  return (
    <>
      <TopBar />
      {children}
    </>
  );
}

export default dynamic(() => Promise.resolve(BasicLayout), {
  ssr: false,
});
